import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`[your-frontend-project]`}</inlineCode>{` = `}<inlineCode parentName="p">{`admin`}</inlineCode>{` `}{`[`}<inlineCode parentName="p">{`rest/graphql`}</inlineCode>{`]`}{` or `}<inlineCode parentName="p">{`shop`}</inlineCode></p>
    </blockquote>
    <h2 {...{
      "id": "for-graphql"
    }}>{`For GraphQL`}</h2>
    <p>{`We have used GraphQL Query and Mutation which is defined in`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd [your-frontend-graphql-project]/src/graphql/
`}</code></pre>
    <p>{`For details documentation:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.apollographql.com/docs/react/"
        }}>{`Apollo Client`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/piglovesyou/graphql-let"
        }}>{`GraphQL Let`}</a></li>
    </ul>
    <p>{`You can check and customize it as your need.`}</p>
    <h3 {...{
      "id": "uses-example"
    }}>{`Uses Example:`}</h3>
    <ul>
      <li parentName="ul">{`Query`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {
  useOrdersQuery,
  OrdersDocument,
  OrderDocument,
  OrdersOrderByColumn,
  SortOrder,
} from "@graphql/orders.graphql";

// Fetch list of orders

const { data, error, loading, fetchMore } = useOrdersQuery({
  variables: {
    orderBy: [{ field: OrdersOrderByColumn.CreatedAt, order: SortOrder.Desc }],
    first: 10,
    page: 1,
    customer_id: 1,
  },
});

fetchMore({
  variables: {
    page,
    first,
  },
});

// Fetch Single Order

const { data, error, loading } = useOrderQuery({
  variables: {
    id,
    tracking_number,
  },
});
`}</code></pre>
    <ul>
      <li parentName="ul">{`Mutation`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {
  useCreateCouponMutation,
  useUpdateCouponMutation,
  useDeleteCouponMutation,
  CouponInput,
  CouponUpdateInput,
  CouponType,
} from "@graphql/coupons.graphql";

const [createCoupon] = useCreateCouponMutation();
const [updateCoupon] = useUpdateCouponMutation();
const [deleteCoupon] = useDeleteCouponMutation();

const handleSubmit = async () => {
  const createInput = {
    code: "eid50",
    amount: 50,
    active_from: "2020-12-20 13:43:32",
    expire_at: "2020-12-30 13:43:32",
    type: CouponType.FixedCoupon,
  };
  const { data, error, loading } = await createCoupon({
    variables: { input: createInput },
  });
  const updateInput: CouponUpdateInput = {
    code: "eid50",
    amount: 100,
    active_from: "2020-12-20 13:43:32",
    expire_at: "2020-12-30 13:43:32",
    type: CouponType.FixedCoupon,
  };
  const { data, error, loading } = await updateCoupon({
    variables: { id: 22, input: updateInput },
  });
  const { data, error, loading } = await deleteCoupon({
    variables: { id: 22 },
  });
};
`}</code></pre>
    <h2 {...{
      "id": "for-rest-api"
    }}>{`For REST API`}</h2>
    <p>{`We have used React Query and Axios which is defined in`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`[your-frontend-rest-project]/src/data/
`}</code></pre>
    <p>{`For details documentation:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://react-query.tanstack.com/"
        }}>{`React-Query`}</a>{`
You can check and customize it as your need.`}</li>
    </ul>
    <h3 {...{
      "id": "uses-example-1"
    }}>{`Uses Example:`}</h3>
    <ul>
      <li parentName="ul">{`Query`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useProductsQuery } from "@data/product/use-products.query";

const {
  isFetching: loading,
  isFetchingNextPage: loadingMore,
  fetchNextPage,
  hasNextPage,
  isError,
  data,
  error,
} = useProductsQuery({
  type: "grocery",
  text: "",
  category: "grocery",
});
`}</code></pre>
    <ul>
      <li parentName="ul">{`Mutation`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useCreateProductMutation } from "@data/product/product-create.mutation";

const {
  mutate: createProduct,
  isLoading: creating,
} = useCreateProductMutation();

function handleSubmit(inputVaues) {
  createProduct(
    {
      ...inputValues,
    },
    {
      onError: (error: any) => {
        Object.keys(error?.response?.data).forEach((field: any) => {
          setError(field, {
            type: "manual",
            message: error?.response?.data[field][0],
          });
        });
      },
    }
  );
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      